import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MoreHoriz as MoreHorizIcon } from "@mui/icons-material";
import {
  Button,
  ClickAwayListener,
  Grow,
  ListItemText,
  MenuItem,
  MenuList,
  Paper,
  Popper,
} from "@mui/material";
import { FileIcon, Grid, SettingIcon } from "../../icons";
import CompanyClaimModal from "../Company/CompanyClaimModal";
import CompanyReportModal from "../Company/CompanyReportModal";
import FullPageProgress from "../FullPageProgress";
import { ToastManager } from "../Toast/ToastManager";
import { SESSION_AUTH } from "../../common/auth";
import { USER_SERVICES } from "../../services";

const AccountActionMenu = props => {
  const { orgName, accountId, accountMenu, reportMenu, claimMenu } = props;
  const [actionMenu, setActionMenu] = useState(false);
  const [requestReport, setRequestReport] = useState(false);
  const [requestClaim, setRequestClaim] = useState(false);
  const anchorRef = useRef(null);
  const navigate = useNavigate();
  const { isUserSession, UPDATE_USER_SESSION, LOGOUT_USER_SESSION } =
    SESSION_AUTH();
  const [loading, setLoading] = useState(false);
  const actionMenuToggle = () => {
    setActionMenu(prevOpen => !prevOpen);
  };
  const actionMenuClose = event => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setActionMenu(false);
  };

  const handleProfileAction = path => {
    if (accountId && accountId !== isUserSession?.org?.id) {
      switchUserAccount(path);
    } else {
      navigate(path);
    }
  };

  const switchUserAccount = path => {
    if (accountId === isUserSession?.org?.id) return;
    setLoading(true);
    USER_SERVICES.switchAccount({
      userId: isUserSession?.userId,
      org: isUserSession?.org?.id,
      switch: accountId,
    })
      .then(data => {
        if (data.code === 200) {
          UPDATE_USER_SESSION({ org: data?.data });
          navigate("/R_C_P", {
            state: { replace: true, redirectOn: path },
          });
        } else if (data.code === 600) {
          LOGOUT_USER_SESSION();
        } else {
          ToastManager.addToast({ title: data.message });
        }
      })
      .catch(error => {
        ToastManager.addToast({ title: error.message });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <React.Fragment>
      {loading && <FullPageProgress fixed />}
      <div className="events6ix-dropdown">
        <Button
          variant="outlined"
          ref={anchorRef}
          className={`events6ix-dropdown-btn events6ix-btn events6ix-btn-sm ${
            actionMenu ? "events6ix-btn-primary" : "events6ix-btn-light"
          }`}
          id="company-profile-banner-action-button"
          aria-controls={
            actionMenu ? "company-profile-banner-action-menu" : undefined
          }
          aria-expanded={actionMenu ? "true" : undefined}
          aria-haspopup="true"
          onClick={actionMenuToggle}
        >
          <MoreHorizIcon />
        </Button>

        <Popper
          open={actionMenu}
          anchorEl={anchorRef.current}
          role={undefined}
          placement="bottom-end"
          transition
          disablePortal
          className="events6ix-dropdown-menu"
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === "bottom-end" ? "right top" : "right bottom",
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={actionMenuClose}>
                  <MenuList
                    autoFocusItem={actionMenu}
                    id="company-profile-banner-action-menu"
                    aria-labelledby="company-profile-banner-action-button"
                    className="events6ix-dropdown-list"
                  >
                    {accountMenu && [
                      <MenuItem
                        key="settings"
                        className="events6ix-dropdown-list-item"
                        onClick={e => {
                          handleProfileAction("/account/setting");
                          actionMenuClose(e);
                        }}
                      >
                        <SettingIcon />
                        <ListItemText>Organization Settings</ListItemText>
                      </MenuItem>,
                      <MenuItem
                        key="dashboard"
                        className="events6ix-dropdown-list-item"
                        onClick={e => {
                          handleProfileAction("/dashboard");
                          actionMenuClose(e);
                        }}
                      >
                        <Grid />
                        <ListItemText>Dashboard</ListItemText>
                      </MenuItem>,
                      <MenuItem
                        key="report"
                        className="events6ix-dropdown-list-item"
                        onClick={e => {
                          handleProfileAction("/investors");
                          actionMenuClose(e);
                        }}
                      >
                        <FileIcon />
                        <ListItemText>Report</ListItemText>
                      </MenuItem>,
                    ]}

                    {accountId && claimMenu && (
                      <MenuItem
                        className="events6ix-dropdown-list-item"
                        onClick={e => {
                          setRequestClaim(true);
                          actionMenuClose(e);
                        }}
                      >
                        <FileIcon />
                        <ListItemText>Claim this business</ListItemText>
                      </MenuItem>
                    )}

                    {accountId && reportMenu && (
                      <MenuItem
                        className="events6ix-dropdown-list-item"
                        onClick={e => {
                          setRequestReport(true);
                          actionMenuClose(e);
                        }}
                      >
                        <FileIcon />
                        <ListItemText>Report issue</ListItemText>
                      </MenuItem>
                    )}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
      {accountId && requestReport && (
        <CompanyReportModal
          open={requestReport}
          accountId={accountId}
          orgName={orgName}
          onClose={() => setRequestReport(false)}
        />
      )}
      {accountId && requestClaim && (
        <CompanyClaimModal
          open={requestClaim}
          accountId={accountId}
          orgName={orgName}
          onClose={() => setRequestClaim(false)}
        />
      )}
    </React.Fragment>
  );
};

export default AccountActionMenu;
